import { dataProps, optionProps, qualityItemProps, subProcessListProps } from './properties'

export const setProductionStageList = (state, payload) => {
    state.list = payload
} 

export const setProductionStageAllList = (state, payload) => {
    state.all_list = payload
} 

export const setProductionStageData = (state, payload) => {
    state.props = payload.response
    
    if(state.props.option_list.length === 0) {
        state.props.option_list = [JSON.parse(JSON.stringify(optionProps))]
    } else if(payload.copy) {
        state.props.option_list.forEach(element => {
            element.id = 0
        })
    }

    if(state.props.quality_point_list.length === 0) {
        state.props.quality_point_list = [JSON.parse(JSON.stringify(qualityItemProps))]
    } else if(payload.copy) {
        state.props.quality_point_list.forEach(element => {
            element.id = 0
        })
    }

    if(state.props.sub_process_list.length === 0) {
        state.props.sub_process_list = [JSON.parse(JSON.stringify(subProcessListProps))]
    } else if(payload.copy) {
        state.props.sub_process_list.forEach(element => {
            element.id = 0
        })
    }

    let key = 0
    state.props.option_list.forEach(element => {
        element.key = key
        key ++
    })

    key = 0
    state.props.quality_point_list.forEach(element => {
        element.key = key
        key ++
    })

    key = 0
    state.props.sub_process_list.forEach(element => {
        element.key = key
        key ++
    })


} 

export const addNewProductionOptionItemRow = state => {

    let key = 0
    state.props.option_list.push(JSON.parse(JSON.stringify(optionProps)))

    state.props.option_list.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        document.getElementById('option_name_'+(key-1)).focus()
    }, 300);

}

export const removeProductionOptionItemRow = (state, payload) => {

    let key = 0

    state.props.deleted_option_list_items.push(state.props.option_list[payload])

    state.props.option_list.splice(payload, 1)

    if(state.props.option_list.length === 0) {
        state.props.option_list = [JSON.parse(JSON.stringify(optionProps))]
    }

    state.props.option_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const addNewQualityPointItemRow_ProductionStage = state => {

    let key = 0
    state.props.quality_point_list.push(JSON.parse(JSON.stringify(qualityItemProps)))

    state.props.quality_point_list.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        document.getElementById('quality_point_'+(key-1)).focus()
    }, 300);

}

export const removeQualityPointItemRow_ProductionStage = (state, payload) => {

    let key = 0

    state.props.deleted_quality_point_list_items.push(state.props.quality_point_list[payload])

    state.props.quality_point_list.splice(payload, 1)

    if(state.props.quality_point_list.length === 0) {
        state.props.quality_point_list = [JSON.parse(JSON.stringify(qualityItemProps))]
    }

    state.props.quality_point_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const sortProductionStageList = (state, payload) => {

    let key = (payload.sl_no)

    if(payload.sort == 1) {
        state.list[key].sl_no = payload.sl_no+1
        state.list[key+1].sl_no = payload.sl_no         
    } else if(payload.sort == 0) {
        state.list[key].sl_no = payload.sl_no-1
        state.list[key-1].sl_no = payload.sl_no         
    }

    state.list = state.list.sort( (a,b) => { 
        var x = a.sl_no < b.sl_no? -1:1; 
        return x; 
    });

}

export const addNewProductionSubProcessItemRow = state => {

    let key = 0
    state.props.sub_process_list.push(JSON.parse(JSON.stringify(subProcessListProps)))

    state.props.sub_process_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const removeProductionSubProcessItemRow = (state, payload) => {

    let key = 0

    state.props.delete_sub_process_list_items.push(state.props.sub_process_list[payload])

    state.props.sub_process_list.splice(payload, 1)

    if(state.props.sub_process_list.length === 0) {
        state.props.sub_process_list = [JSON.parse(JSON.stringify(subProcessListProps))]
    }

    state.props.sub_process_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const resetProductionStageData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}



// WEBPACK FOOTER //
// ./src/store/modules/productionStage/mutations.js